module.exports = __webpack_public_path__ + "static/media/worldwide-reach.5348ded8.jpg";